import { render } from "./Toast.vue?vue&type=template&id=c1a504f0&scoped=true"
import script from "./Toast.js?vue&type=script&lang=js"
export * from "./Toast.js?vue&type=script&lang=js"

import "./Toast.scss?vue&type=style&index=0&id=c1a504f0&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Mariana Costa\\MyProjects\\lets-play\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1a504f0"]])

export default __exports__